<template>
    <div>
        <div class="group row" v-if="!$parent.status.complete">
            <div class="col" style="position: relative">
                <button type="submit" class="ctaButton cta-pill filled-red icon right-arrow" :disabled="$parent.status.idle">Submit</button>
            </div>
        </div>

        <div class="response">
            <div v-if="$parent.status.idle" class="spinner"></div>
            <div class="type" v-bind:class="{ [`-${$parent.response.type}`]: $parent.response.type }">
                <h3 style="margin: 1rem 0 0 0" v-if="$parent.response.type === 'confirmation' || $parent.response.type === 'error'">{{ $parent.response.message }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'submit-confirmation'
    }
</script>
